import Label from "./Label";
import { cx } from "./util";

/** Bordered card led by a small ASCII diagram of the mechanism. */
export default function FeatureCard({ title, label, glyph, featured = false, children, className, style }) {
  return (
    <div className={cx("gd-card", featured && "gd-card-featured", className)} style={style}>
      {glyph && <pre className="gd-ascii gd-card-glyph" aria-hidden="true">{glyph}</pre>}
      {label && <Label>{label}</Label>}
      <h3>{title}</h3>
      <p>{children}</p>
    </div>
  );
}
